const CircularLoader = ({ size = 24, color = "border-blue-600" }) => {
  return (
    <div
      className={`
        ${color}
        border-2
        border-t-transparent
        rounded-full
        animate-spin
      `}
      style={{
        width: size,
        height: size,
      }}
    />
  );
};

export default CircularLoader;
